import { formSectionSlotRecipe } from './form-section.slot-recipe';
import { selectTableSlotRecipe } from './select-table.slot-recipe';

export const slotRecipes = {
	formSection: formSectionSlotRecipe,
	selectTable: selectTableSlotRecipe,
};
